module.exports = new __parcel__URL__("urban-heat.2826acd5.jpg").toString();